export const loadingBackdropBackgroundStyles = {
  color: "#ffffff",
  zIndex: (theme) => theme.zIndex.drawer + 1,
};
